export default __webpack_public_path__ + "static/media/gallery_11.b8b81b63.jpg";